export default {
  NAME: 'name',
  EMAIL: 'email',
  CODE: 'code',
  DATE_CRON: 'generateReportCron',
};
